if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      }); 

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}

/* ===== PDP COLOR SWATCHES UX ===== */
(function () {
  const STORAGE_KEY = 'lamel_pdp_scroll';

  // Клік на свотч — зберігаємо позицію
  document.addEventListener('click', (e) => {
    const prev = e.target.closest('.lamel-pdp-prev');
    const next = e.target.closest('.lamel-pdp-next');

    if (prev) {
      const vp = prev.closest('.lamel-pdp-wrapper')?.querySelector('.lamel-pdp-viewport');
      if (vp) vp.scrollBy({ left: -120, behavior: 'smooth' });
      return;
    }

    if (next) {
      const vp = next.closest('.lamel-pdp-wrapper')?.querySelector('.lamel-pdp-viewport');
      if (vp) vp.scrollBy({ left: 120, behavior: 'smooth' });
      return;
    }

    const dot = e.target.closest('[data-option-type="swatch_color"]');
    if (dot) {
      const vp = dot.closest('.lamel-pdp-viewport');
      if (vp) sessionStorage.setItem(STORAGE_KEY, vp.scrollLeft);
    }
  });

  // Drag desktop
  document.addEventListener('mousedown', (e) => {
    const viewport = e.target.closest('.lamel-pdp-viewport');
    if (!viewport) return;

    let startX = e.pageX - viewport.offsetLeft;
    let sl = viewport.scrollLeft;
    viewport.style.cursor = 'grabbing';

    function onMove(e) {
      e.preventDefault();
      viewport.scrollLeft = sl - (e.pageX - viewport.offsetLeft - startX) * 1.5;
    }

    function onUp() {
      viewport.style.cursor = '';
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    }

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  });

// Оновлюємо стрілки
  function updateArrows(vp) {
    const wrapper = vp.closest('.lamel-pdp-wrapper');
    if (!wrapper) return;
    const prev = wrapper.querySelector('.lamel-pdp-prev');
    const next = wrapper.querySelector('.lamel-pdp-next');
    const hasOverflow = vp.scrollWidth > vp.clientWidth + 2;
    wrapper.classList.toggle('has-overflow', hasOverflow);
    if (prev) prev.classList.toggle('is-disabled', vp.scrollLeft <= 2);
    if (next) next.classList.toggle('is-disabled', vp.scrollLeft >= vp.scrollWidth - vp.clientWidth - 2);
  }

  function initViewport(vp) {
    if (vp.__lamelInited) return;
    vp.__lamelInited = true;
    updateArrows(vp);
    vp.addEventListener('scroll', () => updateArrows(vp), { passive: true });
    new ResizeObserver(() => updateArrows(vp)).observe(vp);
  }

// Слідкуємо тільки в межах PDP, а не всього body
let lamelPdpObserverQueued = false;

function restoreAndInitViewports() {
  const saved = sessionStorage.getItem(STORAGE_KEY);

  if (saved) {
    const vp = document.querySelector('.lamel-pdp-viewport');

    if (vp && !vp.__scrollRestored) {
      vp.__scrollRestored = true;
      sessionStorage.removeItem(STORAGE_KEY);

      requestAnimationFrame(() => {
        vp.scrollLeft = parseFloat(saved);
      });
    }
  }

  document.querySelectorAll('.lamel-pdp-viewport').forEach(initViewport);
}

function scheduleRestoreAndInitViewports() {
  if (lamelPdpObserverQueued) return;

  lamelPdpObserverQueued = true;

  requestAnimationFrame(() => {
    lamelPdpObserverQueued = false;
    restoreAndInitViewports();
  });
}

const lamelPdpObserverRoot =
  document.querySelector('product-info[id^="MainProduct"]') ||
  document.querySelector('.m-main-product') ||
  document.body;

new MutationObserver(scheduleRestoreAndInitViewports).observe(lamelPdpObserverRoot, {
  childList: true,
  subtree: true
});

restoreAndInitViewports();

})();